const DEFAULT_MAX_LINE_LENGTH = 15;
const SAFE_BREAK_CHARS = new Set(['(', ')', '+', '-', '*', '/', '×', '÷', ',']);

export const formatCalculatorForChat = (expression: string, maxLineLength = DEFAULT_MAX_LINE_LENGTH): string[] => {
    if (expression.length <= maxLineLength) {
        return [expression];
    }

    const eqIndex = expression.lastIndexOf('=');

    const exprPart = eqIndex !== -1 ? expression.slice(0, eqIndex) : expression;

    const resultPart = eqIndex !== -1 ? expression.slice(eqIndex) : '';

    const lines = splitPreservingTokens(exprPart, maxLineLength);

    if (resultPart) {
        const last = lines[lines.length - 1];

        if (last.length + resultPart.length <= maxLineLength) {
            lines[lines.length - 1] = last + resultPart;
        } else {
            lines.push(resultPart);
        }
    }

    return lines;
};

const splitPreservingTokens = (input: string, maxLineLength: number): string[] => {
    const lines: string[] = [];
    let current = '';
    let lastSafeBreak = -1;

    for (let i = 0; i < input.length; i++) {
        const char = input[i];
        current += char;

        // Track safe break positions
        if (SAFE_BREAK_CHARS.has(char)) {
            lastSafeBreak = current.length;
        }

        // If we exceed max length
        if (current.length > maxLineLength) {
            if (lastSafeBreak !== -1) {
                // Break at last safe position
                lines.push(current.slice(0, lastSafeBreak));
                current = current.slice(lastSafeBreak);
            } else {
                // No safe break → force split
                lines.push(current.slice(0, maxLineLength));
                current = current.slice(maxLineLength);
            }

            lastSafeBreak = -1;
        }
    }

    if (current) {
        lines.push(current);
    }

    return lines;
};
